<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">


        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-muted">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()"><i class="fa fa-building fa-1x push-5-r"></i>  {{labelTitleBanner[actualLanguage]}}</h2>
            </div>

            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Unit Detail Information  -->
                    <div  class="block">

                        <h6 class="push">{{labelExplanation[actualLanguage]}}</h6>


                        <h2 class="block-title push">{{labelAddTitle[actualLanguage]}}</h2>
                        
                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-3">
                              <h6>{{labelTagName[actualLanguage]}}</h6>
                              <input v-model="tagName" class="form-control align-left " type="test"  placeholder="">
                          </div>
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelTagDescription[actualLanguage]}}</h6>
                              <input v-model="tagDescription" class="form-control align-left" type="test"  placeholder="">
                          </div>
                          <div class="col-xs-12 col-sm-3">
                            <h6 style="color:white;">-</h6>
                            <button  type="button" @click="addUnitTag()" class="btn btn-block btn-default margin-bottom" name="buttonAddPlanItem">
                              <spinner size="small" v-if="tagIsSaving"></spinner>
                              <span v-else><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddUnitTag[actualLanguage] }}</span></button>
                          </div>

                        </div>


                        <h2 class="block-title push">{{labelTagListTitle[actualLanguage]}}</h2>
                        

                        <div class="col-xs-12 col-md-12 push">
                          <div class="table-responsive push">
                              <table class="table table-striped table-vcenter">
                                  <thead>
                                      <tr>
                                          <th style="width: 25%;">{{tableTagColumnTitle01[actualLanguage]}}</th>
                                          <th style="width: 60%;">{{tableTagColumnTitle02[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 10%;">{{tableTagColumnTitle03[actualLanguage]}}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for= "(Tag,index) in tagList">
                                          <td class="font-w600">{{Tag.tagName}}</td>
                                          <td>{{Tag.tagDescription}}</td>
                                          <td class="text-center">
                                              <div class="btn-group">
                                                  <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                  @click="deleteUnitTag(index)" title="Supprimer/Delete"><i class="fa fa-trash"></i></button>
                                              </div>
                                          </td>
                                      </tr>

                                  </tbody>
                              </table>

                          </div>
                        </div>
                    </div>
                    <!-- END Static Labels -->

                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'


export default {
  name: 'UnitTag',
 
  data() {
    return {
      flagDisplayBanner : 0,
      flagDisplayDetail : 0,

      actualLanguage : "FR",
      labelTitleBanner: {FR: "Configurateur des étiquette d'unité", EN: 'Unit tag configurator'},

      labelAddTitle: {FR: "Ajout de d'étiquette d'unité à votre organisation", EN: 'Adding a unit tag to your organization'},
      labelExplanation: {FR: "La création de d'étiquette d'unité permet de comparer les consommations de services entre les unités de même type. Vous pouvez créer une liste personalisée pour votre organisation.",
                         EN: 'The creation of a unit tags makes it possible to compare the consumption of services between units of the same type. You can create a custom list for your organization.'},

      labelTagName: {FR: "Nom de l'étiquette d'unité", EN: 'Unit tag name'},
      labelTagDescription: {FR: "Description du l'étiquette d'unité", EN: 'Unit tag description'},
      tagName : '',
      tagDescription:'',
      tagList : [],
      tagIsSaving : false,
      labelButtonAddUnitTag: {FR: "Ajouter l'étiquette", EN: 'Add this tag'},


      labelTagListTitle: {FR: "Liste des étiquette", EN: 'Tags list'},

      tableTagColumnTitle01: {FR: "Nom de l'étiquette", EN: "Tag name"},
      tableTagColumnTitle02: {FR: "Description", EN: "Description"},
      tableTagColumnTitle03: {FR: "Supprimer", EN: "Delete"},

      messageRemoveConfirmA:{FR: "Confirmer la supression de l'étiquette: ", EN: 'Confirm tag deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},


    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.flagDisplayBanner = ~this.flagDisplayBanner
      this.getUnitTags()
    },


  addUnitTag(){
      this.tagIsSaving = true
        var requestData = {'postAction':'AddUnitTag',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'tagName':this.tagName,
                          'tagDescription':this.tagDescription}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
              this.tagIsSaving = false
            if(response.data.Code=='OK'){
                this.tagName = ''
                this.tagDescription = ''
                this.tagList = response.data.UnitTagsList
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },

  getUnitTags(){

        var requestData = {'postAction':'GetUnitTags',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.tagList = response.data.UnitTagsList
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },


  deleteUnitTag(index){
        var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.tagList[index].tagName, this.messageRemoveConfirmB[this.actualLanguage]);

        if(confirmation=='DELETE'){
            var requestData = {'postAction':'DeleteUnitTag',
                              'bundleId':this.actualBundle.bundle_id,
                              'parentContainer':this.parentContainer,
                              'tagId':this.tagList[index].tagId}

            this.$store.dispatch('sessionStore/postBundle', requestData)
                .then((response) => {
                  //console.log(response)
                if(response.data.Code=='OK'){
                    this.tagList = response.data.UnitTagsList
                    }
                    else{
                      window.alert(response.data.PromptMessage[this.actualLanguage])
                      }
                })
        }
    },

    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// CompUnitTagsDisplay.vue?2544a8a2